export default __webpack_public_path__ + "static/media/team24.56f8ce0a.JPG";